const actionTypes = { SET_NTH_BRAND: 'SET_NTH_BRAND' };

module.exports = actionTypes;
